import React from 'react';

import CombinedMarketingOptIn from '@rover/components/src/MarketingOptIn';
import {
  type MarketingOptInChannels,
  type MarketingOptInPetType,
  MarketingOptInPromptVariation,
} from '@rover/components/src/MarketingOptIn/types';
import useCountryConfigurationShim from '@rover/shared/js/hooks/useCountryConfigurationShim';
import useCurrentUserShim from '@rover/shared/js/hooks/useCurrentUserShim';
import useMarketingOptInShim from '@rover/shared/js/hooks/useMarketingOptInShim';

import MarketingOptIn from './MarketingOptIn';

const MarketingOptInContainer: React.FC = () => {
  const marketingOptInData = useMarketingOptInShim();
  const { currentUrls } = useCountryConfigurationShim();
  const { isImpersonating, user } = useCurrentUserShim();

  if (
    marketingOptInData.variation === MarketingOptInPromptVariation.CONTACTABILITY_M1 &&
    marketingOptInData.shouldShowMarketingOptInModal &&
    !isImpersonating
  ) {
    return (
      <CombinedMarketingOptIn
        onRequestClose={() => marketingOptInData.submitMarketingOptInIntent({ dismissed: true })}
        petType={(marketingOptInData.petType as MarketingOptInPetType) ?? 'dog'}
        channels={(marketingOptInData.channels as MarketingOptInChannels[]) ?? ['email']}
        countryCode={user?.address?.countryCode ?? undefined}
        onOptIn={() => marketingOptInData.submitMarketingOptInIntent({ turnNotificationsOn: true })}
        onDecline={() =>
          marketingOptInData.submitMarketingOptInIntent({ turnNotificationsOn: false })
        }
        onDismiss={() => marketingOptInData.submitMarketingOptInIntent({ dismissed: true })}
      />
    );
  }

  return (
    <MarketingOptIn
      isImpersonating={isImpersonating ?? false}
      currentUrls={currentUrls}
      {...marketingOptInData}
    />
  );
};

export default MarketingOptInContainer;
